import React, { useState } from 'react';
import { LazyLoader } from 'src/components/Helpers/LazyLoader';
import { Svg } from 'src/components/Svg/Svg';
import { Button } from 'src/components/Button/Button';
import classnames from 'classnames';

import classes from './QuickQuote.scss';

const Lazy = React.lazy(() => import(/* webpackChunkName:"__lazy__quickQuoteModal" */ './QuickQuoteModal'));
const Lazy2 = React.lazy(
    () =>
        import(
            /* webpackChunkName:"__lazy__quickQuoteSidebar" */ '../../components/QuickQuoteSidebar/QuickQuoteSidebar'
        ),
);

type Props = {
    sku: string;
    isBundle?: boolean;
    isPcp?: boolean;
    buttonStyle?: boolean;
    cta?: string;
    leftAligned?: boolean;
    noMargin?: boolean;
    defaultMessage?: string;
    fullWidth?: boolean;
};

export const QuickQuote: React.FC<Props> = ({
    sku,
    isBundle,
    isPcp,
    buttonStyle = false,
    cta,
    leftAligned = false,
    noMargin = false,
    defaultMessage,
    fullWidth = false,
}) => {
    const [quoteOpen, setQuoteOpen] = useState(false);

    const quickQuoteClickHandler = () => setQuoteOpen(true);

    if (isBundle || isPcp) {
        return (
            <>
                <div className={classes.quickQuoteBundle}>
                    <h2 className={classes.quickQuoteTitle}>Quick Quote</h2>
                    <p className={classes.quickQuoteText}>Get a quick quote from our experts</p>
                    <Button
                        className={classes.quickQuoteButton}
                        onClick={() => setQuoteOpen(true)}
                        variant="secondary"
                        data-test-id="Quick-quote"
                    >
                        <img src={require('src/components/Svg/svgs/flash2.svg')} alt="Flash icon" />
                        Get Quote
                    </Button>
                    <p className={classes.quickQuoteResponse}>Current Response Time &lt;2 Hours</p>
                </div>
                {quoteOpen && (
                    <LazyLoader
                        fallback={null}
                        loader={<Lazy sku={sku} close={() => setQuoteOpen((prev) => !prev)} quoteOpen={quoteOpen} />}
                    />
                )}
            </>
        );
    } else {
        return (
            <LazyLoader
                fallback={null}
                loader={
                    <Lazy2
                        sku={sku}
                        defaultMessage={defaultMessage}
                        trigger={
                            <div
                                className={classnames(classes.quickQuote, {
                                    [classes.quickQuoteButtonStyle]: buttonStyle,
                                    [classes.leftAligned]: leftAligned,
                                    [classes.noMargin]: noMargin,
                                    [classes.fullWidth]: fullWidth,
                                })}
                                onClick={quickQuoteClickHandler}
                            >
                                {buttonStyle ? (
                                    <a className="button">{cta ? cta : 'Get a quick quote from our experts'}</a>
                                ) : (
                                    <>
                                        <div className={classes.quickQuoteFlashIcon}>
                                            <Svg name="flash" />
                                        </div>
                                        <div className={classes.quickQuoteTextWrapper}>
                                            <p className={classes.quickQuoteText}>Get a quick quote from our experts</p>
                                            <p className={classes.quickQuoteResponse}>
                                                Current Response Time{' '}
                                                <strong className={classes.quickQuoteResponseTime}>&lt;2 Hours</strong>
                                            </p>
                                        </div>
                                        <div className={classes.quickQuoteArrowIcon}>
                                            <div>
                                                <Svg color="secondary" name="arrow-right" />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        }
                    />
                }
            />
        );
    }
};
